export const CONTACTS_FETCH_RESIDENTS_REQUESTED =
  'CONTACTS_FETCH_RESIDENTS_REQUESTED'
export const CONTACTS_FETCH_RESIDENTS_SUCCESS =
  'CONTACTS_FETCH_RESIDENTS_SUCCESS'
export const CONTACTS_FETCH_RESIDENTS_ERROR = 'CONTACTS_FETCH_RESIDENTS_ERROR'

export const CONTACTS_FETCH_OTHERS_REQUESTED = 'CONTACTS_FETCH_OTHERS_REQUESTED'
export const CONTACTS_FETCH_OTHERS_SUCCESS = 'CONTACTS_FETCH_OTHERS_SUCCESS'
export const CONTACTS_FETCH_OTHERS_ERROR = 'CONTACTS_FETCH_OTHERS_ERROR'

export const CONTACTS_FETCH_BOARDCONTACTS_REQUESTED =
  'CONTACTS_FETCH_BOARDCONTACTS_REQUESTED'
export const CONTACTS_FETCH_BOARDCONTACTS_SUCCESS =
  'CONTACTS_FETCH_BOARDCONTACTS_SUCCESS'
export const CONTACTS_FETCH_BOARDCONTACTS_ERROR =
  'CONTACTS_FETCH_BOARDCONTACTS_ERROR'

export const CONTACTS_FETCH_BOARDCONTACT_REQUESTED =
  'CONTACTS_FETCH_BOARDCONTACT_REQUESTED'
export const CONTACTS_FETCH_BOARDCONTACT_SUCCESS =
  'CONTACTS_FETCH_BOARDCONTACT_SUCCESS'
export const CONTACTS_FETCH_BOARDCONTACT_ERROR =
  'CONTACTS_FETCH_BOARDCONTACT_ERROR'

export const CONTACTS_MANAGE_BOARDCONTACT_REQUESTED =
  'CONTACTS_MANAGE_BOARDCONTACT_REQUESTED'
export const CONTACTS_MANAGE_BOARDCONTACT_SUCCESS =
  'CONTACTS_MANAGE_BOARDCONTACT_SUCCESS'
export const CONTACTS_MANAGE_BOARDCONTACT_ERROR =
  'CONTACTS_MANAGE_BOARDCONTACT_ERROR'
export const CONTACTS_MANAGE_BOARDCONTACT_RESET =
  'CONTACTS_MANAGE_BOARDCONTACT_RESET'

export const CONTACT_UNITS_FETCH_REQUESTED = 'CONTACT_UNITS_FETCH_REQUESTED'
export const CONTACT_UNITS_FETCH_SUCCESS = 'CONTACT_UNITS_FETCH_SUCCESS'
export const CONTACT_UNITS_FETCH_ERROR = 'CONTACT_UNITS_FETCH_ERROR'
export const CONTACT_UNITS_RESET = 'CONTACT_UNITS_RESET'

export const CONTACT_UPDATE_REQUESTED = 'CONTACT_UPDATE_REQUESTED'
export const CONTACT_UPDATE_SUCCESS = 'CONTACT_UPDATE_SUCCESS'
export const CONTACT_UPDATE_ERROR = 'CONTACT_UPDATE_ERROR'

export const CONTACTS_SET_SEARCHTEXT = 'CONTACTS_SET_SEARCHTEXT'
export const CONTACTS_RESIDENTS_SET_FILTERS = 'CONTACTS_RESIDENTS_SET_FILTERS'
export const CONTACTS_OTHERS_SET_FILTERS = 'CONTACTS_OTHERS_SET_FILTERS'
export const CONTACTS_BOARDCONTACTS_SET_FILTERS =
  'CONTACTS_BOARDCONTACTS_SET_FILTERS'
export const CONTACTS_SET_SECTION = 'CONTACTS_SET_SECTION'
